const TAX_RATE = 0.07;

export const roundPurchaseAmount = (value) =>
  Math.round((Number(value ?? 0) + Number.EPSILON) * 100) / 100;

// ใช้ยอด totalNetPrice ของตั๋วเป็นยอดเป้าหมาย แล้วกระจายกลับตาม item.netPrice
// เพื่อให้ผลรวมรายการตรงกับยอดท้าย PDF ของตั๋ว
export const getAdjustedPurchaseItems = (transaction) => {
  const rows = (transaction?.items || [])
    .map((item) => ({
      item,
      weight: Number(item.netWeight ?? item.weight ?? 0),
      baseAmount: Number(item.netPrice ?? 0),
    }))
    .filter(({ weight, baseAmount }) => weight > 0 || baseAmount !== 0);

  const targetAmount = roundPurchaseAmount(transaction?.totalNetPrice ?? 0);
  const baseTotal = rows.reduce((sum, row) => sum + row.baseAmount, 0);
  const ratio = baseTotal !== 0 ? targetAmount / baseTotal : 0;
  const isVat = transaction?.isVat ?? false;
  let allocatedAmount = 0;

  return rows.map(({ item, weight, baseAmount }, index) => {
    const isLastItem = index === rows.length - 1;
    const amountBeforeVat = isLastItem
      ? roundPurchaseAmount(targetAmount - allocatedAmount)
      : roundPurchaseAmount(baseAmount * ratio);
    allocatedAmount += amountBeforeVat;
    const vat = isVat ? amountBeforeVat * TAX_RATE : 0;

    return {
      ...item,
      netWeight: weight,
      pricePerUnit:
        weight > 0
          ? amountBeforeVat / weight
          : Number(item.pricePerUnit ?? 0),
      amountBeforeVat,
      vat,
      netPrice: amountBeforeVat + vat,
    };
  });
};
